
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(1(545|8|889)|9(324|391|807)|2086|2188|372|4896|5154|6803|7489|7875)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
